
define('text!templates/modules/calendar/activity/member/detail/blocks/about-activity.html',[],function () { return '<h4 class="activity-name-text" data-bind="html:name">{{name}}</h4>\n<p class="activity-description-text" data-bind="markdown:sup_description">{{description}}</p>\n<div class="date-input"></div>\n';});

